module.exports = __webpack_public_path__ + "img/zhuce.593f07df.jpg";